module.exports = {
  siteTitle: "科大校園人民廣播電台 People's Campus Radio, HKUSTSU", // <title>
  shortSiteTitle: "科大電台", // <title> ending for posts and pages
  siteDescription: "科大校園人民廣播電台 People's Campus Radio, HKUSTSU",
  siteUrl: "https://radio.su.ust.hk/",
  // pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",

  /* author */
  authorName: "greg lobinski",
  authorTwitterAccount: "greglobinski",

  /* info */
  headerTitle: "greg lobinski",
  headerSubTitle: "presents another one GatsbyJS starter",

  /* manifest.json */
  manifestName: "HeroBlog - a GatsbyJS starter",
  manifestShortName: "HeroBlog", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/greglobinski" },
    { name: "twitter", url: "https://twitter.com/greglobinski" },
    { name: "facebook", url: "http://facebook.com/greglobinski" }
  ]
};
